import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { CaseAction } from "interfaces/case-action";
import { AxiosContext } from "contexts/AxiosContext";

const STALE_TIME = 0;

export const useCaseActionQuery = (
  id: number | undefined
): UseQueryResult<CaseAction, unknown> => {
  const { axios } = useContext(AxiosContext)!;

  return useQuery({
    queryKey: ["case_actions", id],
    queryFn: async () => {
      const { data } = await axios.get<CaseAction>(`/case_actions/${id}`);

      return data;
    },
    staleTime: STALE_TIME,
    enabled: !!id
  });
};
